import React, { useEffect, useState } from 'react';

import NotificationMessage, { type NotificationVariant } from 'components/partials/notification/notification';

import Notification from 'components/partials/notification/notification.helper';

interface FlashNotificationState {
  heading?: string;
  message?: string;
  variant?: string;
}

interface FlashNotificationProps {
  customClass?: string;
  children?: React.ReactNode;
}

const FlashNotification = ({ customClass = '', children }: FlashNotificationProps): React.JSX.Element | null => {
  const [{ heading, message, variant }, setNotification] = useState<FlashNotificationState>(
    Notification.notification
  );

  const removeNotification = () => {
    setNotification({});
    Notification.clear();
  };

  useEffect(() => {
    const currentNotification = Notification.notification;

    if (
      currentNotification.heading &&
      currentNotification.heading !== heading
    ) {
      setNotification(currentNotification);
    }
  }, []);

  useEffect(() => {
    if (!!heading) {
      const timer = setTimeout(() => removeNotification(), 5000);

      return () => clearTimeout(timer);
    }

    return undefined;
  }, [heading]);

  useEffect(
    () => () => {
      Notification.clear();
    },
    []
  );

  if (!heading) return null;

  return (
    <NotificationMessage
      heading={heading}
      message={message}
      variant={variant as NotificationVariant}
      removeNotification={removeNotification}
      customClass={customClass}
    >
      {children}
    </NotificationMessage>
  );
};

export default FlashNotification;
